import React, { useState } from 'react';
import { useFormik } from 'formik';
import { Row, Col } from 'react-bootstrap';
import DateFild from '../../../components/DateTimePicker/DateFild';
import Loader from '../../../components/Loader/Loader';
import { postVerificationAndMonitoring } from '../../../apiservices/ApiServices';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/en';

const VerificationMonitoring = ({ details, postUpdateData, toast }) => {
    const [isLoadings, setLoadings] = useState(false);

    const initialValues = {
        id: details?.verification_monitoring?.id || '',
        methodOfVerification: details?.verification_monitoring?.method_of_verification || '',
        verificationResponsible: details?.verification_monitoring?.Verification_Responsible || '',
        verificationDate: details?.verification_monitoring?.Verification_Date || dayjs().format('DD/MM/YYYY'),
        effectivenessOutcome: details?.verification_monitoring?.Effectiveness_Outcome || [], // Checkbox array: ["Effective", "Needs Rework", "Not Effective"]
        effectivenessOutcomeDetail: details?.verification_monitoring?.Effectiveness_Outcome_remarks || '',
        verificationNotes: details?.verification_monitoring?.notes || '',
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        enableReinitialize: true,
        onSubmit: async (values) => {
            setLoadings(true);
            const payload = {
                id: values.id,
                incident_header_id: details.header_id,
                method_of_verification: values.methodOfVerification,
                verification_responsible: values.verificationResponsible,
                verification_date: values.verificationDate,
                effectiveness_outcome: values.effectivenessOutcome,
                effectiveness_outcome_remarks: values.effectivenessOutcomeDetail,
                notes: values.verificationNotes,
            };

            try {
                const res = await postVerificationAndMonitoring(payload);
                console.log("res", res.data);
                toast.success(res.data.message);
                postUpdateData();
            } catch (error) {
                toast.error(error?.response?.data?.message || 'Something went wrong');
            } finally {
                setLoadings(false);
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue } = formik;

    return (
        <>
            <div className="form-box">
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="fieldset verification_monitoring">
                        <h1>Verification & monitoring</h1>
                        <div className="formsBox">
                            <Row>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Method of Verification</label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="methodOfVerification"
                                            value={values.methodOfVerification}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Verification Responsible</label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="verificationResponsible"
                                            value={values.verificationResponsible}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4} className='rd-100'>
                                    <div className="form-group">
                                        <label>Verification Date</label>
                                        <DateFild
                                            value={values.verificationDate}
                                            onChange={(date) => setFieldValue('verificationDate', date)}
                                        />
                                    </div>
                                </Col>
                                <Col md={6} className='rd-100'>
                                    <div className="form-group">
                                        <label>Effectiveness Outcome</label>
                                        <div className="radiogroups">
                                            {["Effective", "Needs Rework", "Not Effective"].map(
                                                (option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="effectivenessOutcome"
                                                                value={option}
                                                                checked={values.effectivenessOutcome === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="effectivenessOutcomeDetail"
                                            placeholder="Details"
                                            value={values.effectivenessOutcomeDetail}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={6} className='rd-100'>
                                    <div className="form-group">
                                        <label>Notes</label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="verificationNotes"
                                            value={values.verificationNotes}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className="button-boxs grid pb-2">
                            <button type="submit" className="btn btn-orange">Submit</button>
                        </div>
                    </div>
                </form>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    );
}

export default VerificationMonitoring